import { create } from '@bufbuild/protobuf';

import { wsAppRequestManager } from '../WsAppApi';
import {
  CreateCallRequest,
  CreateCallRequestSchema,
  CreateRoomRequest,
  CreateRoomRequestSchema,
  DeclineCallRequest,
  DeclineCallRequestSchema,
} from '../types/call/call_requests_pb';
import {
  type CreateCallResponse,
  CreateRoomResponse,
  DeclineCallResponse,
} from '../types/call/call_responses_pb';
import { WsRequest } from './request.types';

export function declineCallRequest(
  data: WsRequest<DeclineCallRequest>
): Promise<DeclineCallResponse> {
  return wsAppRequestManager.request<DeclineCallResponse>({
    case: 'declineCall',
    value: create(DeclineCallRequestSchema, data),
  });
}

export function createCallRequest(data: WsRequest<CreateCallRequest>): Promise<CreateCallResponse> {
  return wsAppRequestManager.request<CreateCallResponse>({
    case: 'createCall',
    value: create(CreateCallRequestSchema, data),
  });
}

export function createRoomRequest(data: WsRequest<CreateRoomRequest>): Promise<CreateRoomResponse> {
  return wsAppRequestManager.request<CreateRoomResponse>({
    case: 'createRoom',
    value: create(CreateRoomRequestSchema, data),
  });
}
